import { css } from "styled-components";
import defaultTheme from "@material-ui/core/styles/defaultTheme";
import { DRAWER_WIDTH } from "../../resource/constants";

const focusShifted = css`
  ${[defaultTheme.breakpoints.down("sm")]} {
    right: calc(50% - 10vmin - ${DRAWER_WIDTH / 2}px);
  }
`;

export default focusShifted;
